import _ from 'underscore';

export function indexToNumber(index: number): string {
  return `${index + 1}`;
}

export function indexToLetter(index: number): string {
  const letter = String.fromCharCode(97 + (index % 26));
  const repeats = Math.floor(index / 26) + 1;
  return Array(repeats + 1).join(letter);
}

export function indexToRomanNumeral(index: number): string {
  index += 1;
  const roman = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
  const decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  let romanNumeral = '';

  for (const [romanD, decimalD] of _.zip(roman, decimal)) {
    while (index >= decimalD) {
      index -= decimalD;
      romanNumeral += romanD;
    }
  }
  return romanNumeral;
}
